import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { MaterialPlaningPopup } from './MaterialPlaningTable';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import moment from 'moment';
import { decryptAES } from '../../../utils/Encryption';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class MaterialPlaning extends Component {

    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        //this.masterEntryServices = new MasterEntryServices();
        this.transactionStockServices = new TransactionStockServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            isLoading: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            itemRowData: [],
            itemColDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            dtMaterialPlanning: [],
            materialObject: {
                idMaterialPlanning: 0,
                updateStatus: 0,
                idCustomer: 0,
                CustomerList: [],
                idWorkOrder: 0,
                workOrderList: [],
                idProduct: 0,
                productList: [],
                planingQuantity: 0,
                idSalesInvoice: 0,
                e_Date: "",
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                idCustomer: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "customer"
                        ),
                    },
                ],
                idWorkOrder: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "work order"
                        ),
                    },
                ],
                idProduct: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "product"
                        ),
                    },
                ],
            },
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.resetDetailsFields();
        this.resetFields();
        this.setState({ isModalOpen: true }, () => {
            this.usp_Master_PartyAccountSelectCustomerForPlanning();
        })
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.usp_Transaction_MaterialPlanningSelectbyId2(event.data.idMaterialPlanning);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    handleCellClick = (event) => {
        this.procSelectAllRecord2GridviewSP(event.data.idMaterialPlanning);
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.materialObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChange = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.materialObject;
        details[name] = value;
        this.setState({ materialObject: details });
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    }

    handleChangeForDropdown = (event, name) => {
        let details = this.state.materialObject;
        details[name] = event.value;
        //if (name === 'idCustomer') {
        //    details.address = event.partyAddress;
        //}
        // if (name === 'idGatepass') {
        //     details.idVendor = this.state.partyAccountList.find((x) => x.label === event.party).value
        //     details.address = this.state.partyAccountList.find((x) => x.label === event.party).partyAddress
        // }
        this.setState({ materialObject: details }, () => {
            if (name === 'idCustomer') {
                this.usp_Transaction_WorkOrderRecvSelectbyIdCustomer_NotinMateralPlanning();
            } else if (name === 'idWorkOrder') {
                this.usp_Transaction_WorkOrderRecvSelectbyId_ForMaterialPlanning();
            } else if (name === 'idProduct') {
                this.usp_Transaction_WorkOrderProductsSelect();
            }
        });
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name, companyName: prop.companyName }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Master_PartyAccountSelectCustomerForPlanning();
            });
        }
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Material Planning",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            width: this.getPinnedColumnWidth(key) !== undefined ? this.getPinnedColumnWidth(key) : window.innerWidth * 0.05,
                            //pinned: ["sR.No", "jobWorkNo", "jobWorkInwardDate", "jobWorkFrom", "invoiceNo"].includes(key) ? "left" : undefined,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idMaterialPlanning"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Material Planning",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id, "Material Planning");
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }
    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "sRNo": window.innerWidth * 0.05,
            "planningDate": window.innerWidth * 0.07,
            "woRecvNo": window.innerWidth * 0.05,
            "customer": window.innerWidth * 0.25,
            "itemName": window.innerWidth * 0.2,
            "woRecvDate": window.innerWidth * 0.07,
            "closeStatus": window.innerWidth * 0.05,
        }
        return colwidth[key]
    }
    getPinnedColumnWidth = (key) => {
        const colwidth = {
            // "sR.No": window.innerWidth * 0.05,
            // "jobWorkNo": window.innerWidth * 0.09,
            // "jobWorkInwardDate": window.innerWidth * 0.08,
            // "jobWorkFrom": window.innerWidth * 0.08,
            // "invoiceNo": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id) => {
        let request = {
            id: id,
            formname: "Material Planning",
            allowToRateVisible: 1,
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth2(key) !== undefined ? this.getColumnWidth2(key) : window.innerWidth * 0.06,
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }

    getColumnWidth2 = (key) => {
        const colwidth = {
            "itemName": window.innerWidth * 0.15,
            "minimumStock": window.innerWidth * 0.06,
            "mrsQty": window.innerWidth * 0.05,
            "piQty": window.innerWidth * 0.05,
            "qcQty": window.innerWidth * 0.05,
            "storeQty": window.innerWidth * 0.05,
            "rejectQty": window.innerWidth * 0.05,
            "issueQty": window.innerWidth * 0.05,
            "requiredQuantity": window.innerWidth * 0.06,
            "totalRequiredQuantity": window.innerWidth * 0.06,
            "mrsQuantity": window.innerWidth * 0.06,
            "piQuantity": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    usp_Master_PartyAccountSelectCustomerForPlanning = () => {
        this.transactionStockServices.usp_Master_PartyAccountSelectCustomerForPlanning([this.state.idCompany, this.state.materialObject.updateStatus, this.state.materialObject.idCustomer]).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idPartyAccount,
                        label: x.partyACName,
                        partyAddress: x.p_Address
                    }));
                    let obj = this.state.materialObject;
                    obj.CustomerList = dynamicData;
                    this.setState({ materialObject: obj }, () => {
                        //this.getMasterAccountHeadSelect();
                    }, () => {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                        }
                    });
                } else {
                    //this.getMasterAccountHeadSelect();
                }
            }
        });
    }


    usp_Transaction_WorkOrderRecvSelectbyIdCustomer_NotinMateralPlanning = () => {
        let request = [
            this.state.materialObject.idCustomer,
            this.state.materialObject.idMaterialPlanning,
            this.state.materialObject.updateStatus,
            this.state.materialObject.idMaterialPlanning    //idSalesInvoice,
        ];
        this.transactionStockServices.usp_Transaction_WorkOrderRecvSelectbyIdCustomer_NotinMateralPlanning(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idwoOrderRecv,
                        label: x.woRecvNo + " - " + x.priority,
                        //partyAddress: x.p_Address
                    }));
                    let obj = this.state.materialObject;
                    obj.workOrderList = dynamicData;
                    this.setState({ materialObject: obj }, () => {
                        //this.getMasterAccountHeadSelect();
                    });
                }
            }
        });
    }

    usp_Transaction_WorkOrderRecvSelectbyId_ForMaterialPlanning = () => {
        let request = [
            this.state.materialObject.idWorkOrder,
            this.state.materialObject.updateStatus,
            0
        ];
        this.transactionStockServices.usp_Transaction_WorkOrderRecvSelectbyId_ForMaterialPlanning(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent[1];
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idwoOrderRecvItems,
                        label: x.itemName,
                        drawingNo: x.drawingNo,
                        //partyAddress: x.p_Address
                    }));
                    let obj = this.state.materialObject;
                    obj.productList = dynamicData;
                    this.setState({ materialObject: obj });
                }
            }
        });
    }

    usp_Transaction_WorkOrderProductsSelect = () => {
        this.transactionStockServices.usp_Transaction_WorkOrderProductsSelect(this.state.materialObject.idProduct).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent[0];
                let obj = this.state.materialObject;
                obj.planingQuantity = 0;
                obj.drawingNo = dynamicData.drawingNo;
                if (dynamicData) {
                    obj.planingQuantity = dynamicData.pendingQty;
                }
                this.setState({ materialObject: obj });
            }
        });
    }

    click_AddBomData = async () => {
        if (this.state.materialObject.idProduct > 0) {
            //await this.addWoBomData();
            //await this.modifyQty();
            let request = [
                this.state.materialObject.idProduct,
                this.state.idCompany,
                this.state.materialObject.planingQuantity
            ];
            this.setState({ isLoading: true });
            this.transactionStockServices.addWoBomData(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent;
                    this.setState({ dtMaterialPlanning: dynamicData });
                    this.setState({ isLoading: false });
                } else {
                    this.setState({ isLoading: false });
                }
            });
        }
    }

    // addWoBomData = async () => {
    //     let response = await this.transactionStockServices
    //         .usp_Transaction_WorkOrderRecvProductsSelectbyId(this.state.materialObject.idProduct);

    //     if (response.statusCode == 200 && response.responseItem !== null) {
    //         let obj = this.state.materialObject;
    //         let handleRes1 = response.responseItem.responseContent;
    //         let _dtMaterialPlanning = this.state.dtMaterialPlanning;

    //         if (handleRes1.length > 0) {
    //             let idwoproduct = obj.idProduct;
    //             let iditem = handleRes1[0].idItem;
    //             let qty = obj.planingQuantity;
    //             let totalWoqty = obj.planingQuantity;

    //             let request = [iditem, this.state.idCompany];

    //             let response2 = await this.transactionStockServices
    //                 .usp_Master_ProductReceipeSelect_ForWOItem(request);

    //             if (response2.statusCode == 200 && response2.responseItem !== null) {
    //                 let handleRes2 = response2.responseItem.responseContent;
    //                 if (handleRes2.length > 0) {
    //                     for (const x of handleRes2) {
    //                         var finalqty = x.requiredQuantity * qty;
    //                         let drCheck = _dtMaterialPlanning?.filter(item => item.idItem === x.idItem);

    //                         if (!drCheck || drCheck.length === 0) {
    //                             var datarow = {
    //                                 idWOOrderRecvItems: idwoproduct,
    //                                 idItem: x.idItem,
    //                                 drawingNo: x.drawingNo,
    //                                 itemType: x.itemType,
    //                                 itemName: x.itemName,
    //                                 minimumStock: x.minimumStock,
    //                                 requiredQuantity: x.requiredQuantity,
    //                                 totalRequiredQuantity: finalqty,
    //                                 isParent: 1,
    //                                 isChild: 0,
    //                                 parentId: 0,
    //                             };

    //                             _dtMaterialPlanning.push(datarow);

    //                             if (x.count > 0) {
    //                                 await this.checkExistingBom(x.idItem, totalWoqty, idwoproduct, 0, 1, x.idItem, _dtMaterialPlanning);
    //                             }
    //                         } else {
    //                             for (const drRow of drCheck) {
    //                                 var qtyFinal = Number(drRow.totalRequiredQuantity) + finalqty;
    //                                 drRow.requiredQuantity = x.requiredQuantity;
    //                                 drRow.totalRequiredQuantity = qtyFinal;
    //                             }
    //                             let drCheck2 = _dtMaterialPlanning.filter(item => item.parentId === x.idItem);
    //                             if (drCheck2.length > 0) {
    //                                 for (const drRow of drCheck2) {
    //                                     drRow.requiredQuantity = x.requiredQuantity;
    //                                     drRow.totalRequiredQuantity = Number(drRow.totalRequiredQuantity) + finalqty;
    //                                 }
    //                             }
    //                             this.setState({ dtMaterialPlanning: drCheck2 });
    //                             await this.checkExistingBom(x.idItem, x.requiredQuantity, idwoproduct, 0, 1, x.idItem, _dtMaterialPlanning);
    //                         }
    //                     }

    //                     this.setState({ dtMaterialPlanning: _dtMaterialPlanning });
    //                 }
    //             }
    //         }
    //     }
    // }

    checkExistingBom = async (id, totalWoqty, idwoitem, ischild, isparent, parentid, _dtMaterialPlanning) => {
        //let _dtMaterialPlanning = this.state.dtMaterialPlanning;

        let request = [
            this.state.materialObject.idProduct,
            this.state.idCompany,
            id
        ];

        let response = await this.transactionStockServices
            .usp_Master_ProductReceipeSelect_ForWOItem_ForExisitingItem(request);

        if (response.statusCode == 200 && response.responseItem !== null) {
            let dynamicData = response.responseItem.responseContent;
            let obj = this.state.materialObject;

            if (dynamicData.length > 0) {
                for (const y of dynamicData) {
                    var qty = obj.planingQuantity;
                    var finalqty = y.requiredQuantity ? Number(y.requiredQuantity * totalWoqty) : 0;
                    var min = y.minimumStock ?? 0;

                    let drCheck = _dtMaterialPlanning.filter(item => item.idItem === y.idItem);

                    if (!drCheck || drCheck.length === 0) {
                        var datarow = {
                            idWOOrderRecvItems: idwoitem,
                            idItem: y.idItem,
                            drawingNo: y.drawingNo,
                            itemType: y.itemType,
                            itemName: y.itemName,
                            minimumStock: y.minimumStock,
                            requiredQuantity: y.requiredQuantity,
                            totalRequiredQuantity: y.requiredQuantity * qty,
                            isParent: isparent,
                            isChild: ischild,
                            parentId: parentid
                        };

                        _dtMaterialPlanning.push(datarow);
                        //this.setState({ dtMaterialPlanning: _dtMaterialPlanning });
                        //debugger;
                        if (y.count > 0) {
                            await this.checkExistingBom(y.idItem, totalWoqty, idwoitem, 1, 0, y.idItem, _dtMaterialPlanning);
                        }
                    } else {
                        let TotalRequiredQuantity = _dtMaterialPlanning
                            .filter(item => item.idItem === parentid)
                            .reduce((acc, row) => acc + (row.totalRequiredQuantity || 0), 0);

                        for (const z of drCheck) {
                            z.requiredQuantity = y.requiredQuantity;
                            z.totalRequiredQuantity = y.totalRequiredQuantity + TotalRequiredQuantity + finalqty;
                        }

                        let drCheck2 = _dtMaterialPlanning.filter(item => item.parentId === y.idItem);
                        if (drCheck2.length > 0) {
                            for (const drRow of drCheck2) {
                                drRow.requiredQuantity = y.requiredQuantity;
                                drRow.totalRequiredQuantity = drRow.totalRequiredQuantity + finalqty + TotalRequiredQuantity;
                            }
                        }
                    }
                }
                this.setState({ dtMaterialPlanning: _dtMaterialPlanning });
            }
        }
    }

    modifyQty = async () => {
        let _dtMaterialPlanning = this.state.dtMaterialPlanning;

        for (const x of _dtMaterialPlanning) {
            if (x.parentId > 0) {
                let drCheck3 = _dtMaterialPlanning.filter(item => item.parentId === x.idItem);

                if (drCheck3.length > 0) {
                    for (const drRow2 of drCheck3) {
                        const sum2 = _dtMaterialPlanning
                            .filter(row => row.idItem === drRow2.parentId)
                            .reduce((acc, row) => acc + (row.totalRequiredQuantity || 0), 0);

                        drRow2.totalRequiredQuantity = drRow2.requiredQuantity * sum2;
                    }
                }
            }
        }
        this.setState({ dtMaterialPlanning: _dtMaterialPlanning });
    }


    submit = () => {
        // guard against double-submit (rapid double-click / impatient re-click while the save is in flight)
        if (this.isSubmitting) {
            return;
        }
        //const isValidAllFields = this.isValidAllFields();
        //if (isValidAllFields) {
        if (this.state.dtMaterialPlanning.length === 0) {
            this.SwalServices.Alert("Please add product items details");
        } else {
            let data = this.state.materialObject;
            let dtMaterialPlanning = this.state.dtMaterialPlanning;
            let request = {
                idMaterialPlanning: data.idMaterialPlanning,
                date: new Date().toISOString(),
                idCustomer: data.idCustomer,
                idWOOrderRecv: data.idWorkOrder,
                idItem: data.idProduct,
                idCompany: this.state.idCompany,
                e_Date: data.e_Date ? data.e_Date : new Date().toISOString(),
                e_IDUser: data.updateStatus === 1 ? this.state.idUser : null,
                isUpdated: data.updateStatus === 1 ? true : false,
                updatedDate: data.updateStatus === 1 ? new Date().toISOString() : null,
                u_IDUser: data.updateStatus === 1 ? this.state.idUser : null,
                isDeleted: false,
                deletedDate: null,
                d_IDUser: null,
                planningQty: data.planingQuantity,
                idFinancialYear: null
            };
            request.itemList = [];
            dtMaterialPlanning.map((x) => {
                let obj = {
                    idMaterialPlanning: data.idMaterialPlanning,
                    idItem: x.idItem,
                    idWOOrderRecvItems: x.idWOOrderRecvItems,
                    idWOOrderRecv: data.idWorkOrder,
                    requiredQuantity: x.requiredQuantity,
                    totalRequiredQuantity: x.totalRequiredQuantity,
                    isParent: x.isParent,
                    isChild: x.isChild,
                    parentId: x.parentId,
                    minimumStock: x.minimumStock
                }
                request.itemList.push(obj);
            });
            this.isSubmitting = true;
            this.setState({ isSaving: true });
            this.transactionStockServices.usp_Transaction_MaterialPlanningInsertUpdate(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent;
                    if (data !== null) {
                        if (this.state.materialObject.updateStatus === 1) {
                            this.SwalServices.Success("Updated sucessfully.");
                        } else {
                            this.SwalServices.Success("Save sucessfully.");
                        }
                        if (this.state.urlId) {
                            this.setState({ route: '/ledger-report' });
                        } else {
                            this.resetFields();
                            this.procSelectAllRecordsSP();
                            this.usp_Transaction_WorkOrderRecvSelectbyId_ForMaterialPlanning()
                            this.setState({
                                // isModalOpen: false,
                                //receiptDetails: reset
                            }, () => {
                            });
                        }
                    }
                }
            }).finally(() => {
                this.isSubmitting = false;
                this.setState({ isSaving: false });
            });
        }
        //}
    }

    resetFields = () => {
        let data = this.state.materialObject;
        data.idMaterialPlanning = 0;
        data.updateStatus = 0;
        // data.idCustomer = 0;
        //data.CustomerList = [];
        // data.idWorkOrder = 0;
        data.workOrderList = [];
        data.idProduct = 0;
        data.productList = [];
        data.planingQuantity = 0;
        data.idSalesInvoice = 0;
        data.e_Date = "";
        this.setState({ materialObject: data, dtMaterialPlanning: [] });
    }

    clear = () => {
        let data = this.state.materialObject;
        data.updateStatus = 0;
        data.idCustomer = 0;
        data.idWorkOrder = 0;
        data.workOrderList = [];
        data.idProduct = 0;
        data.productList = [];
        data.planingQuantity = 0;
        data.idSalesInvoice = 0;
        data.e_Date = "";
        this.setState({ materialObject: data, dtMaterialPlanning: [] });
    }

    usp_Transaction_MaterialPlanningSelectbyId2 = async (id) => {
        let request = [id, this.state.idCompany];
        let response = await this.transactionStockServices.usp_Transaction_MaterialPlanningSelectbyId2(request);

        if (response.statusCode == 200 && response.responseItem !== null) {
            let dynamicData = response.responseItem.responseContent[0][0];
            let dynamicData2 = response.responseItem.responseContent[1];

            let obj = this.state.materialObject;
            obj.idMaterialPlanning = dynamicData.idMaterialPlanning;
            obj.updateStatus = 1;
            obj.idCustomer = dynamicData.idCustomer;
            obj.idWorkOrder = dynamicData.idwoOrderRecv;
            obj.workOrderList = [];
            obj.idProduct = dynamicData.idwoOrderRecvItems;
            obj.productList = [];
            obj.planingQuantity = dynamicData.planningQty;
            obj.idSalesInvoice = dynamicData.idSalesInvoice;
            obj.e_Date = dynamicData.e_Date;

            let requestWorkOrderList = [
                dynamicData.idCustomer,
                dynamicData.idMaterialPlanning,
                1,
                dynamicData.idMaterialPlanning
            ];

            let responseWorkOrderList = await this.transactionStockServices
                .usp_Transaction_WorkOrderRecvSelectbyIdCustomer_NotinMateralPlanning(requestWorkOrderList);

            if (responseWorkOrderList.statusCode == 200 && responseWorkOrderList.responseItem !== null) {
                let resDropdown = responseWorkOrderList.responseItem.responseContent;
                if (resDropdown.length > 0) {
                    resDropdown = resDropdown.map((x) => ({
                        value: x.idwoOrderRecv,
                        label: x.woRecvNo + " - " + x.priority,
                    }));
                    obj.workOrderList = resDropdown;
                }
            }

            let requestProductList = [
                dynamicData.idwoOrderRecv,
                1,
                dynamicData.idMaterialPlanning
            ];
            let responseProductList = await this.transactionStockServices
                .usp_Transaction_WorkOrderRecvSelectbyId_ForMaterialPlanning(requestProductList);
            if (responseProductList.statusCode == 200 && responseProductList.responseItem !== null) {
                let resProductList = responseProductList.responseItem.responseContent[1];
                if (resProductList.length > 0) {
                    resProductList = resProductList.map((x) => ({
                        value: x.idwoOrderRecvItems,
                        label: x.itemName,
                        drawingNo: x.drawingNo,
                    }));
                    obj.productList = resProductList;
                }
            }
            this.setState({ materialObject: obj, dtMaterialPlanning: dynamicData2, isModalOpen: true }, () => {
                this.usp_Master_PartyAccountSelectCustomerForPlanning()
                this.usp_Transaction_WorkOrderProductsSelect()
            });
        }
    }

    // usp_Transaction_MaterialPlanningSelectbyId2 = (id) => {
    //     let request = [id, this.state.idCompany];
    //     this.transactionStockServices.usp_Transaction_MaterialPlanningSelectbyId2(request).then((response) => {
    //         if (response.statusCode == 200 && response.responseItem !== null) {
    //             let dynamicData = response.responseItem.responseContent[0][0];
    //             let dynamicData2 = response.responseItem.responseContent[0];
    //             let obj = this.state.materialObject;
    //             obj.idMaterialPlanning = dynamicData.idMaterialPlanning;
    //             obj.updateStatus = 1;
    //             obj.idCustomer = dynamicData.idCustomer;
    //             //obj.CustomerList = [];
    //             obj.idWorkOrder = dynamicData.idWOOrderRecv;
    //             obj.workOrderList = [];
    //             obj.idProduct = dynamicData.idItem;
    //             obj.productList = [];
    //             obj.planingQuantity = dynamicData.planningQty;
    //             obj.idSalesInvoice = dynamicData.idSalesInvoice;
    //             obj.e_Date = dynamicData.e_Date;
    //             let requestWorkOrderList = [
    //                 dynamicData.idCustomer,
    //                 dynamicData.idMaterialPlanning,
    //                 1,
    //                 dynamicData.idSalesInvoice   //idSalesInvoice,
    //             ];
    //             let responseWorkOrderList = await this.transactionStockServices.usp_Transaction_WorkOrderRecvSelectbyIdCustomer_NotinMateralPlanning(requestWorkOrderList);
    //             if (responseWorkOrderList.statusCode == 200 && responseWorkOrderList.responseItem !== null) {
    //                 let resDropdown = responseWorkOrderList.responseItem.responseContent;
    //                 if (resDropdown.length > 0) {
    //                     resDropdown = resDropdown.map((x) => ({
    //                         value: x.idwoOrderRecv,
    //                         label: x.priority,
    //                     }));
    //                     obj.workOrderList = dynamicData;
    //                 }
    //             }

    //             let requestProductList = [
    //                 dynamicData.idWOOrderRecv,
    //                 1,
    //             ];
    //             let responseProductList = await this.transactionStockServices.usp_Transaction_WorkOrderRecvSelectbyId_ForMaterialPlanning(requestProductList);
    //             if (responseProductList.statusCode == 200 && responseProductList.responseItem !== null) {
    //                 let resProductList = responseProductList.responseItem.responseContent;
    //                 if (resProductList.length > 0) {
    //                     resProductList = resProductList.map((x) => ({
    //                         value: x.idwoOrderRecvItems,
    //                         label: x.itemName + " - " + x.drawingNo,
    //                     }));
    //                     obj.productList = resProductList;
    //                 }
    //             }

    //             this.setState({ materialObject: obj });
    //         }
    //     });
    // }

    render() {
        return (
            <div className='material-planing'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <MaterialPlaningPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            materialObject={this.state.materialObject}
                            handleChange={this.handleChange.bind(this)}
                            onGridReady={this.onGridReady.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            isSaving={this.state.isSaving}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}
                            itemColDefs={this.state.itemColDefs}
                            handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                            click_AddBomData={this.click_AddBomData.bind(this)}
                            dtMaterialPlanning={this.state.dtMaterialPlanning}
                            clear={this.clear.bind(this)}
                            isLoading={this.state.isLoading}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Material planing</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    onCellClicked={this.handleCellClick}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>

                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    headerHeight={60}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
